<div>
  <h2>{{ 'LiveChat::WaitTimePredictionSettings' | abpLocalization }}</h2>
  <hr />
  <form [formGroup]="form" *ngIf="isInitialized" (ngSubmit)="save()" validateOnSubmit>
    <div class="form-group form-check mb-2">
      <input
        type="checkbox"
        class="form-check-input"
        id="enableWaitTimePredictionMessage"
        formControlName="enableWaitTimePredictionMessage"
      />
      <label class="form-check-label" for="enableWaitTimePredictionMessage">
        {{ 'LiveChat::WaitTimePredictionSettings:EnableWaitTimePredictionMessage' | abpLocalization }}
      </label>
    </div>

    <div class="form-group mb-2 d-flex flex-column">
      <label for="averageAgentChatDurationForSingleAgent">
        {{ 'LiveChat::WaitTimePredictionSettings:AverageAgentChatDurationForSingleAgent' | abpLocalization }}
      </label>
      <span class="form-text text-muted">
        {{ 'LiveChat::WaitTimePredictionSettings:AverageAgentChatDurationForSingleAgentDescription' | abpLocalization }}
      </span>
      <input
        id="averageAgentChatDurationForSingleAgent"
        type="number"
        class="form-control"
        min="1"
        max="3600"
        formControlName="averageAgentChatDurationForSingleAgent"
      />
    </div>

    <div class="form-group d-flex flex-column">
      <label for="averageFirstResponseTimeForSingleAgent">
        {{ 'LiveChat::WaitTimePredictionSettings:AverageFirstResponseTimeForSingleAgent' | abpLocalization }}
      </label>
      <span class="form-text text-muted">
        {{ 'LiveChat::WaitTimePredictionSettings:AverageFirstResponseTimeForSingleAgentDescription' | abpLocalization }}
      </span>
      <input
        id="averageFirstResponseTimeForSingleAgent"
        type="number"
        class="form-control"
        min="1"
        max="3600"
        formControlName="averageFirstResponseTimeForSingleAgent"
      />
    </div>
  </form>
  <div class="row">
    <div class="col-md-12">
      <hr />
      <div>
        <abp-button iconClass="fa fa-save" (click)="save()" [disabled]="form?.invalid">
          {{ 'AbpUi::Save' | abpLocalization }}
        </abp-button>
      </div>
    </div>
  </div>
</div>
